import React from "react";
import UiTheme from "shared/enums/UiTheme";
import { updateTheme } from "shared/utils";

const defaultThemeContextValue = { theme: "", setTheme: () => {} };

const ThemeContext = React.createContext<ThemeContextType>(defaultThemeContextValue);

export const ThemeProvider = ({ children, clientTheme }: { children: React.ReactNode; clientTheme: UiTheme }) => {
  const [theme, setTheme] = React.useState<string>(UiTheme[clientTheme]);

  React.useEffect(() => {
    updateTheme(theme);
  }, [clientTheme, theme]);

  return (
    <ThemeContext.Provider
      value={{
        setTheme,
        theme
      }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const ctx = React.useContext(ThemeContext);

  if (ctx === undefined) {
    throw new Error("useTheme should be used inside ThemeProvider");
  }
  return ctx;
};
